import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card } from 'semantic-ui-react';
import { withRouter } from 'react-router';

const textStyle = {
  color: '#e6683c',
  fontSize: 16,
  textAlign: 'center',
};

const upgradeButtonStyle = {
  margin: '0 auto',
  display: 'block',
};

const BlockedInvitationStatus = ({
  router,
}) => (
  <Card fluid>
    <Card.Content>
      <h3>Invitation Status</h3>
    </Card.Content>
    <Card.Content>
      <p style={textStyle}>
        You must upgrade your subscription to invite influencers to this campaign.
      </p>
    </Card.Content>
    <Card.Content>
      <Button
        style={upgradeButtonStyle}
        color="pink"
        inverted
        content="Upgrade now"
        fluid
        onClick={() => router.push('/team/manage')}
      />
    </Card.Content>
  </Card>
);

BlockedInvitationStatus.propTypes = {
  router: PropTypes.object.isRequired,
};

export default withRouter(BlockedInvitationStatus);



/** WEBPACK FOOTER **
 ** ./src/components/blocked-invitation-status/index.js
 **/